<template>
    <div v-if="tooltip">
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <div v-on="on">
            <component :is="`icon-${name}`" :size="size"></component>
          </div>
        </template>
        <span>{{tooltip}}</span>
      </v-tooltip>
    </div>

    <div v-else class="inlineBreak">
      <component :is="`icon-${name}`" :size="size"></component>
    </div>

</template>

<script>
import { icons } from 'feather-icons'

const components = Object.values(icons).reduce(
  (prev, curr) => ({
    ...prev,
    [`icon-${curr.name}`]: {
      props: ['size'],
      render (createElement) {
        return createElement('div', {
          style: { display: 'inline-block' },
          domProps: {
            innerHTML: curr.toSvg({ width: this.size, height: this.size })
          }
        })
      }
    }
  }),
  {}
)

export default {
  props: {
    name: {
      type: String,
      validator: value => {
        return icons.hasOwnProperty(value)
      }
    },
    size: {
      type: Number,
      default: 16
    },
    tooltip: {
      type: String,
      default: null
    }
  },
  components
}
</script>

<style scoped lang="sass">
.inlineBreak
  display: inline-block
</style>
